import { render, staticRenderFns } from "./registroemail.vue?vue&type=template&id=5e7dcb3a&scoped=true"
import script from "./registroemail.vue?vue&type=script&lang=js"
export * from "./registroemail.vue?vue&type=script&lang=js"
import style0 from "./registroemail.vue?vue&type=style&index=0&id=5e7dcb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7dcb3a",
  null
  
)

export default component.exports